import { useEffect } from 'react';
export const useAsyncEffect = (fn, deps) => useEffect(() => {
    const props = { visible: true };
    fn(props).catch(() => { });
    return () => {
        props.visible = false;
    };
}, deps);
//# sourceMappingURL=async-effect.js.map